class ChatUser {
    constructor({ uid, name, email, profilePic, dob }) {
        if (!uid || !name || !email) {
            throw new Error('ChatUser entity requires uid, name, and email.');
        }
        this.uid = uid;
        this.name = name;
        this.email = email;
        this.profilePic = profilePic;
        this.dob = dob || null; // Date of birth for birthday notifications
    }
}

export default ChatUser;
